import React from 'react'
import { GetBrandedAppName } from '../../../../../services/BrandingService'
import { Tooltip, tooltipTypes } from '../../../../Global/Tooltip'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

export default function ProgressChartTrendLineLegend(props) {

    const { shouldShowChart, embedded, selectedEquating, trendline, label, trend } = props

    const {t} = useTranslation("progress_report")

    if (!trendline) return null
    if (!(trendline && trendline[trendline.length - 1] && trendline[trendline.length - 1][1])) {
        return null
    }

    if (!shouldShowChart) return null
    if (!selectedEquating) return null
    if (embedded) return null

    let pred_end_year = Math.round(trendline[trendline.length - 1][1] * 10) / 10 + ' ' + label;
    let estimatedMastery = '';
    let estimatedMasteryValue = trend;
    
    if(label === 'ARM') {
        pred_end_year = parseFloat(trendline[trendline.length - 1][1]).toFixed(2) + ' ' + label;
        if (estimatedMasteryValue){
            estimatedMastery = parseFloat(estimatedMasteryValue).toFixed(2) + ' ' + label;
        }
    }
    return (
        <div className='progressChartTrendLineLegendWrapper'>
            {estimatedMasteryValue &&
                <div>
                    <div className='progressLegendSubheader'>
                        <span>{t("Estimated Mastery Today")}</span>
                        <Tooltip type={tooltipTypes.masteryKey} />
                        <br />
                        
                    </div>
                    <div className='progressLegendItem progressTrendlineLegend'>
                        <div className='trendLegendIndicator'> </div>
                        <div className='legendLabel'> {estimatedMastery} </div>
                    </div>
                </div>
            }

            <div>
                <div className='progressLegendSubheader'>
                    <span>{t("Predicted Ability")}</span>
                    <Tooltip type={tooltipTypes.progressKey} />
                    <br />
                    {t("by end of school year")}
                </div>
                <div className='progressLegendItem progressTrendlineLegend'>
                    <div className='trendLegendIndicator predicted'> </div>
                    <div className='legendLabel'> {pred_end_year} </div>
                </div>
            </div>
        </div>
    )
}
